export const getUserUUID = store => store.user.uuid;